import { Button, Grid, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ContentCopy } from "@mui/icons-material";
import { withRouter } from "react-router-dom";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import AddButton from "../../components/AddButton/AddButton";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import moment from "moment";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import { getPMOrderListPage, getPMGetOrderDetailById, deletePMOrder, pmDeleteOrderAfter, setPMGetOrderDetailByIdNull, getMaintenanceType } from "../../store/actions/PMActions";
import { getList } from "../../store/actions/PlannedMaintenanceListActions";
import { useDispatch, useSelector } from "react-redux";
import AssignmentIcon from "@mui/icons-material/AssignmentRounded";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

const plantId = localStorage.getItem("plantId");
const ss = sessionStorage;

function PlannedMaintenanceOrderList(props) {
    let [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    const [rowsLength, setRowsLength] = useState(0);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");
    const [userIList, setUserIList] = useState([]);

    const [state, setState] = useState({
        poolIds: ls.get("pmol_poolId_" + plantId) || [],
        maintenanceNote: ls.get("pmol_maintenanceNote") || null,
        maintenanceTypeId: ls.get("pmol_maintenanceTypeId_" + plantId) || 0,
    });

    const [poolData, setPoolData] = useState([]);
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);

    useEffect(() => {
        LoadHandler();
        dispatch(getList());
        dispatch(getMaintenanceType());
    }, []);

    const dispatch = useDispatch();

    const { pm } = useSelector((PMstate) => PMstate);
    const PlannedMaintenanceList = useSelector((PMstate) => PMstate.PlannedMaintenanceList);
    const {
        user: { userInterfaceList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (userInterfaceList?.resultObject) {
            let interfaceList = userInterfaceList?.resultObject?.interfaceList;
            setUserIList(interfaceList);
        }
    }, [userInterfaceList]);

    useEffect(() => {
        if (pm?.pmOrderListPage?.errorCode === 0) {
            const { resultObject } = pm?.pmOrderListPage;
            setRows(Object.values(resultObject.content));
            setInitialRows(Object.values(resultObject.content));
            setRowsLength(resultObject.totalCount);
            setPageLoaded(true);
        }
        if (pm?.pmOrderById?.resultObject && pm?.showDates) {
            const { resultObject } = pm?.pmOrderById;
            var list = [];
            resultObject.taskDays.forEach((element) => {
                list.push(moment(element).format("DD.MM.YYYY"));
            });
            dispatch(setPMGetOrderDetailByIdNull());
            alert(list.join("\n"));
        }
        if (pm?.pmOrderDelete?.errorCode === 0) {
            dispatch(pmDeleteOrderAfter());
            LoadHandler();
        }
        if (pm?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(pm.maintenanceType.resultObject);
        }
    }, [pm]);

    useEffect(() => {
        if (PlannedMaintenanceList.poolList) {
            setPoolData(Object.values(PlannedMaintenanceList.poolList));
        }
    }, [PlannedMaintenanceList.poolList]);

    const LoadHandler = (pageNumber = currentPage, pageSize = rowsPerPage, filterCleared = false) => {
        const payload = {
            pageNumber: pageNumber + 1,
            pageSize: pageSize,
            body: {
                poolIds: ls.get("pmol_poolId_" + plantId) || [],
                maintenanceTypeId: ls.get("pmol_maintenanceTypeId_" + plantId) || 0,
                orderNote: ls.get("pmol_maintenanceNote") ? ls.get("pmol_maintenanceNote") : null,
                machineId: filterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                sortItem: {
                    propertyName: sortColumn,
                    direction: sortOrder,
                },
            },
        };
        dispatch(getPMOrderListPage(payload));
    };

    //delete
    const DeleteHandler = (row) => {
        ToggleModal();
        dispatch(deletePMOrder(row.id));
    };

    // Search
    const [searchText, setSearchText] = useState("");
    const searchPlannedMaintenanceOrder = (value) => {
        value = value.toLowerCase();
        let filteredItems = initialRows.filter(
            (item) =>
                item &&
                (item.id?.toString().includes(value) ||
                    item.equipmentName?.toLowerCase().includes(value) ||
                    item.equipmentCode?.toLowerCase().includes(value) ||
                    item.poolName?.toLowerCase().includes(value) ||
                    item.maintenanceTypeName?.toLowerCase().includes(value) ||
                    item.notes?.toLowerCase().includes(value))
        );
        setRows(filteredItems);
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const HandleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
        LoadHandler(newPage, rowsPerPage);
    };

    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
        LoadHandler(0, event.target.value);
    };

    // Pool
    const HandlePool = (pool) => {
        let ids = [];
        pool.map((item) => ids.push(item.id));
        setState({ ...state, poolIds: ids });
        ls.set("pmol_poolId_" + plantId, ids);
    };

    // Maintenance Type
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(ls.get("pmol_maintenanceTypeName_" + plantId) || null);
    const HandleMaintenanceTypeChange = (maintenanceName) => {
        if (maintenanceName !== null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceName));
            setSelectedMaintenanceTypeName(filteredType[0].name);
            ls.set("pmol_maintenanceTypeId_" + plantId, filteredType[0].id);
            ls.set("pmol_maintenanceTypeName_" + plantId, filteredType[0].name);
        } else {
            setSelectedMaintenanceTypeName(null);
            ls.set("pmol_maintenanceTypeId_" + plantId, 0);
            ls.set("pmol_maintenanceTypeName_" + plantId, null);
        }
    };

    //Maintenance Note
    const FilterWithMaintenanceNote = (e) => {
        if (e.target.value == null) {
            ls.set("pmol_maintenanceNote", null);
        } else {
            ls.set("pmol_maintenanceNote", e.target.value);
        }

        setState({ ...state, maintenanceNote: e.target.value });
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "pmol",
            selectedAreaCode: isCleared ? null : ss.getItem("pmol_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("pmol_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("pmol_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("pmol_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("pmol_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("pmol_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("pmol_selectedAreaCode");
        ss.removeItem("pmol_selectedAreaName");
        ss.removeItem("pmol_selectedMainEquipmentCode");
        ss.removeItem("pmol_selectedMainEquipmentName");
        ss.removeItem("pmol_selectedSubEquipmentCode");
        ss.removeItem("pmol_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const NavigateToCreatePage = () => {
        props.history.push("/create-planned-maintenance?from=list");
    };

    const NavigateToMultiplePlans = () => {
        props.history.push("/create-multiple-planned-maintenance");
    };

    const NavigateAsEditable = (id) => {
        props.history.push("/create-planned-maintenance?from=list&id=" + id);
    };

    const NavigateCreateCopy = (id) => {
        props.history.push("/create-planned-maintenance?from=list&id=" + id, { copy: true });
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const DeleteButtonHandler = (row) => {
        setDeletedRow(row);
        ToggleModal();
    };

    const ToggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState(0);
    let [sortColumn, setSortColumn] = useState("");
    const HandleSort = (order, column) => {
        setSortOrder(order);
        setSortColumn(column);

        var payload = {
            pageNumber: 1,
            pageSize: rowsPerPage,
            body: {
                poolIds: ls.get("pmol_poolId_" + plantId) || [],
                maintenanceTypeId: ls.get("pmol_maintenanceTypeId_" + plantId) || 0,
                sortItem: {
                    propertyName: column,
                    direction: order,
                },
            },
        };
        dispatch(getPMOrderListPage(payload));
    };

    const ShowDates = (id) => {
        dispatch(getPMGetOrderDetailById({ id, showDates: true }));
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 0 ? "asc" : "desc";

        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`pmol_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {item.label}
                    </TableCell>
                );
            } else if (item.id === "MaintenanceDates") {
                return (
                    <TableCell id={`pmol_rowItems_TableCell_MaintenanceDates_${index}_${item.id}`} align="center">
                        {item.label}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`pmol_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`pmol_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => HandleSort(sortOrder === 1 ? 0 : 1, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const HandleApplyFilter = () => {
        LoadHandler();
    };

    const HandleClearFilter = () => {
        setState({ ...state, poolIds: [], maintenanceNote: "" });
        ls.set("pmol_poolId_" + plantId, []);
        ls.set("pmol_maintenanceNote", null);

        setSelectedMaintenanceTypeName(null);
        ls.set("pmol_maintenanceTypeId_" + plantId, 0);
        ls.set("pmol_maintenanceTypeName_" + plantId, null);

        HandleClearMachineStates();
        LoadHandler(currentPage, rowsPerPage, true);
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return (
            <DetailFilter
                HandlePool={HandlePool}
                poolData={poolData}
                poolIds={state.poolIds}
                HandleMaintenanceTypeChange={HandleMaintenanceTypeChange}
                maintenanceTypes={maintenanceTypes}
                selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                FilterWithPlanNote={FilterWithMaintenanceNote}
                planNote={state.maintenanceNote}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                isAreaNotFiltered={true}
            />
        );
    };

    return (
        <StyledTableDiv>
            <h1>{t("MaintenancePlans")}</h1>
            <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={() => {
                    setIsFilterDrawerOpen(false);
                    HandleApplyFilter();
                }}
                detailFilter={filter()}
            />
            <FilterButton onClick={() => toggleDrawer(true)} />
            {userIList.includes("VIEWER") ? null : <AddButton onClick={() => NavigateToCreatePage()} />}

            {pageLoaded === true ? (
                <React.Fragment>
                    <Grid container spacing={4} alignItems="center" sx={{ marginBottom: 4 }}>
                        <Grid item xs={12} sm={12} md={4}></Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <SearchBar value={searchText} onChange={(newValue) => setSearchText(newValue)} onRequestSearch={(value) => searchPlannedMaintenanceOrder(value)} helperText={true} />
                        </Grid>
                        {userIList.includes("VIEWER") ? null : (
                            <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", justifyContent: "space-around" }}>
                                <Button id="pmol_CreateMultiplePlan" variant="contained" onClick={NavigateToMultiplePlans} startIcon={<AssignmentIcon />}>
                                    {t("Create Multiple Plan")}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </React.Fragment>
            ) : null}
            {rows.length ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="pmol_TableContainer" component={Paper}>
                        <Table id="pmol_Table" aria-label="customized table">
                            <TableHead id="pmol_TableHead">
                                <TableRow id="pmol_TableRow">
                                    {renderTableCell([
                                        { id: "Id", label: t("ID") },
                                        { id: "EquipmentCode", label: t("EquipmentCode") },
                                        { id: "EquipmentName", label: t("EquipmentName") },
                                        { id: "PoolName", label: t("Pool") },
                                        { id: "MaintenanceTypeName", label: t("MaintenanceType") },
                                        { id: "Notes", label: t("MaintenanceNote") },
                                        { id: "plannedPersonCount", label: t("PlannedPersonCount") },
                                        { id: "plannedHoursPerPerson", label: t("Person/Hour") },
                                        { id: "MaintenanceDates", label: t("MaintenanceDates") },
                                        
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.slice().map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell id={`pmol_TableCell_id`} align="center">
                                            {row.id}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_equipmentCode`} align="center">
                                            {row.equipmentCode}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_equipmentName`} align="center">
                                            {row.equipmentName}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_poolName`} align="center">
                                            {row.poolName}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_maintenanceTypeName`} align="center">
                                            {row.maintenanceTypeName}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_notes`} align="center">
                                            {row.notes}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_plannedPersonCount`} align="center">
                                            {row.plannedPersonCount}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_plannedHoursPerPerson`} align="center">
                                            {row.plannedHoursPerPerson}
                                        </TableCell>
                                        <TableCell id={`pmol_TableCell_ShowDates`} align="center">
                                            <Button onClick={() => ShowDates(row.id)} variant="contained" color="primary">
                                                {" "}
                                                {t("SeeDates")}{" "}
                                            </Button>
                                        </TableCell>
                                        {userIList.includes("VIEWER") ? null : (
                                            <TableButtons
                                                id="pmol_TableButtons`"
                                                table={"PlannedMaintenance"}
                                                row={row}
                                                icon={<ContentCopy />}
                                                title={t("CopyMaintenance")}
                                                enableEditHandler={() => NavigateAsEditable(row.id)}
                                                deleteButtonHandler={() => DeleteButtonHandler(row)}
                                                navigateCreateCopy={() => NavigateCreateCopy(row.id)}
                                                detail={false}
                                            />
                                        )}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            id="pmol_TablePagination"
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rowsLength}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={HandleChangePage}
                            onRowsPerPageChange={HandleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}

            <Modal id="pmol_Modal" title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => DeleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={ToggleModal} />
            <LoadingBackdrop id="pmol_lbd" />
        </StyledTableDiv>
    );
}

export default withRouter(PlannedMaintenanceOrderList);
